<template>
  <el-dialog
    title="添加作者"
    class="small-dialog"
    :visible.sync="dialogVisible"
    v-dialogDrag
    :close-on-click-modal="false"
    :before-close="closeDialog"
    append-to-body
  >
    <div class="mb-20px">
      <el-button type="primary" size="small" @click="openAddUser" :disabled="disabled"
        >添加系统人员</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="authorDialogVisible = true"
        :disabled="disabled"
        >添加系统外人员</el-button
      >
    </div>
    <el-table :data="tableData" height="385px" border stripe>
      <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="userName" label="工号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="deptName" label="部门" show-overflow-tooltip></el-table-column>
      <el-table-column label="作者类型">
        <template slot-scope="scope">
          <el-select size="small" class="w-full" v-model="scope.row.type" :disabled="disabled">
            <el-option
              label="视频作者"
              :value="columnTypeEnum.columnVideo"
              v-if="columnType === columnTypeEnum.columnVideo"
            ></el-option>
            <template v-else>
              <el-option label="文字作者" :value="columnTypeEnum.columnText"></el-option>
              <el-option label="图片作者" :value="columnTypeEnum.columnImgText"></el-option>
            </template>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" v-if="!disabled">
        <template slot-scope="scope">
          <el-button size="mini" @click="deleteRow(scope.$index)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="text-center">
      <el-button
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save"
        v-if="!disabled"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="closeDialog()">取消</el-button>
    </div>
    <wiz-tree-select
      :visible.sync="userDialogVisible"
      :treeData="orgUserTree"
      treeCheckField="isActive"
      @save="addSystemUser"
      :defaultSelectKeys="defaultSelectKeys"
      title="添加系统人员"
      treeNodeKey="key"
      repeatKey="id"
      :filterRepeat="true"
    />
    <el-dialog
      title="添加系统外人员"
      class="mini-dialog"
      :visible.sync="authorDialogVisible"
      v-dialogDrag
      :close-on-click-modal="false"
      :before-close="closeAuthorDialog"
      append-to-body
    >
      <el-form :model="form" label-width="150px" :rules="rules" label-position="right" ref="form">
        <el-form-item label="作者姓名" prop="name">
          <el-input clearable v-model="form.name" placeholder="请输入作者姓名" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button size="small" type="primary" class="iconfont icon-save" @click="addAuthor"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="closeAuthorDialog()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { treeToOneArray } from '@/assets/js/Common'
import { informationPublishMap } from '../js/config'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 已选作者数据
    authorData: {
      type: Array,
      required: true,
    },
    // 已选部门数据
    deptData: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 当前作者类型
    type: {
      type: Number,
      default: 1,
    },
    // 栏目类型
    columnType: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableData: [],
      columnTypeEnum: informationPublishMap.column,
      userDialogVisible: false,
      authorDialogVisible: false,
      defaultSelectKeys: [],
      orgUserTree: [],
      deptList: [],
      flattenData: [],
      form: {
        name: '',
      },
      rules: {
        name: [{ required: true, message: '请输入作者姓名', trigger: 'blur' }],
      },
      deleteData: [],
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    dialogVisible: {
      immediate: true,
      async handler(val) {
        if (this.orgUserTree.length === 0) {
          await this.getOrgUserTree()
        }
        if (val) {
          this.tableData = []
          // 回显作者列表数据
          _.forEach(this.authorData, (item) => {
            // 通过id获取组织机构树中的人员（可能存在多个）
            const userList = _.filter(this.flattenData, (data) => {
              return data.id === item.id
            })
            // 获取对应已选部门的作者
            const author =
              _.find(userList, (user) => {
                return this.deptData.includes(user.topPid)
              }) || userList[0]
            // 存在则为系统人员，不存在则为系统外人员
            if (author) {
              this.tableData.push({
                name: author.name,
                userName: author.userName,
                deptId: author.topPid,
                deptName:
                  _.find(this.deptList, { organizationUnitId: author.topPid })
                    ?.organizationUnitName || '',
                type: item.type,
                id: author.id,
              })
            } else {
              this.tableData.push({
                name: item.id,
                type: item.type,
              })
            }
          })
        }
      },
    },
  },
  methods: {
    async getOrgUserTree() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserTree({})
      if (!err && res.length) {
        this.orgUserTree = this.processedTreeData(res[0].childen)
        this.flattenData = treeToOneArray(this.orgUserTree, 'children')
        this.deptList = treeToOneArray(res, 'childen')
      }
    },
    processedTreeData(treeData, topItem) {
      const hanldeData = []
      treeData.forEach((item) => {
        const cloneTreeItem = _.cloneDeep(item)
        cloneTreeItem.label = item.organizationUnitName
        cloneTreeItem.id = item.organizationUnitId
        cloneTreeItem.key = item.organizationUnitId
        let hanldeChildren = []
        if (item.childen && item.childen.length) {
          hanldeChildren = this.processedTreeData(item.childen, topItem || item)
        }
        const userList = _.map(item.userList, (user) => {
          return {
            ...user,
            key: `${item.organizationUnitId}-${user.id}`,
            label: user.name,
            topPid: topItem ? topItem.organizationUnitId : item.organizationUnitId,
          }
        })
        delete cloneTreeItem.userList
        delete cloneTreeItem.childen
        cloneTreeItem.children = [...hanldeChildren, ...userList]
        hanldeData.push(cloneTreeItem)
      })
      return hanldeData
    },
    openAddUser() {
      this.defaultSelectKeys = _.compact(
        _.map(this.tableData, (item) => {
          return item.id
        })
      )
      this.userDialogVisible = true
    },
    addSystemUser(data) {
      const newData = _.map(data, (item) => {
        return {
          name: item.name,
          userName: item.userName,
          deptId: item.topPid,
          deptName:
            _.find(this.deptList, { organizationUnitId: item.topPid })?.organizationUnitName || '',
          type: this.type,
          id: item.id,
        }
      })
      this.tableData = _.uniqWith([...this.tableData, ...newData], (arrval, othVal) => {
        return arrval.id === othVal.id && arrval.type === othVal.type
      })
    },
    deleteRow(index) {
      this.deleteData = _.uniqWith([...this.deleteData, this.tableData[index]], _.isEqual)
      this.tableData.splice(index, 1)
    },
    addAuthor() {
      const isRepeat = _.find(this.tableData, (item) => {
        return !item.id && item.name === this.form.name
      })
      if (isRepeat) {
        this.$message.warning(`已存在系统外人员"${this.form.name}"`)
        return
      }
      this.tableData.push({
        name: this.form.name,
        type: this.type,
      })
      this.closeAuthorDialog()
    },
    closeAuthorDialog(done) {
      this.form = this.$options.data().form
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.authorDialogVisible = false
      }
    },
    closeDialog(done) {
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
    save() {
      this.$emit('save', this.tableData, this.deleteData)
      this.closeDialog()
    },
  },
}
</script>

<style></style>
